import { createContext, useContext, useState } from "react";

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [deviceId, setDeviceId] = useState("");
  const [date, setDate] = useState("");
  const [devices, setDevices] = useState([]);
  const [selectedValue, setTabValue] = useState('1');
const updatebutton =()=>{

    return "updatemystring";
}
  return (
    <AppContext.Provider value={{ deviceId, setDeviceId, date, setDate , devices, setDevices, selectedValue, setTabValue, updatebutton}}>
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => useContext(AppContext);
